import { useState, useEffect, useCallback } from 'react';
import useScrollSpy from '../../hooks/useScrollSpy';
import { ReactComponent as Logo } from '../../assets/logo-light.svg';
import './Nav.css';

const sectionIds = ['about', 'experience', 'projects', 'contact'];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const activeId = useScrollSpy(sectionIds, 80);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = useCallback((e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    document.querySelectorAll('.fade-in').forEach((n) => n.classList.add('visible'));
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner container">
        <a href="/" className="nav__logo" aria-label="Bill Bates — Home">
          <Logo className="nav__logo-svg" />
        </a>

        <button
          className={`nav__hamburger ${menuOpen ? 'nav__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
          {sectionIds.map((id) => (
            <a
              key={id}
              href={`#${id}`}
              className={`nav__link ${activeId === id ? 'nav__link--active' : ''}`}
              onClick={(e) => scrollTo(e, id)}
            >
              {id.charAt(0).toUpperCase() + id.slice(1)}
            </a>
          ))}
          <a
            href="/wbates_resume.docx"
            download
            className="nav__resume"
          >
            Resume
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
